__turbopack_context__.v({
  "container": "index-module-scss-module__kuSLca__container",
  "form": "index-module-scss-module__kuSLca__form",
});
